import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import moment from "moment";
import CustomerStoreService from "services/CustomerStoreService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllCustomerStore = createAsyncThunk(
  "customerStore/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.getAll(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getCustomerStoreById = createAsyncThunk(
  "customerStore/getById",
  async ({ customerId, storeId }, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.getById(customerId, storeId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createCustomerStore = createAsyncThunk(
  "customerStore/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CustomerStoreService.create(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateCustomerStore = createAsyncThunk(
  "customerStore/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CustomerStoreService.update(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteCustomerStore = createAsyncThunk(
  "customerStore/delete",
  async (data, { rejectWithValue }) => {
    try {
      const { customerId, onSuccess } = data;

      const response = await CustomerStoreService.delete(customerId);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const settingCustomerReward = createAsyncThunk(
  "customerStore/reward",
  async (data, { rejectWithValue }) => {
    try {
      const { payload, onSuccess } = data;
      const response = await CustomerStoreService.settingReward(payload);
      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportCustomerStoreExcel = createAsyncThunk(
  "customerStore/exportExcel",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await CustomerStoreService.exportExcel(params);
      const url = window.URL.createObjectURL(blob);
      const filename = `Danh sách khách hàng.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const importCustomerGoogleSheets = createAsyncThunk(
  "customerStore/importGoogleSheets",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CustomerStoreService.importGoogleSheets(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getHistoryOrders = createAsyncThunk(
  "customerStore/getHistoryOrders",
  async (params, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.getHistoryOrders(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// CUSTOMER V2
export const getAllCustomer = createAsyncThunk(
  "customerStore/getAllCustomer",
  async (params, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.getAllCustomer(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getCustomerById = createAsyncThunk(
  "customerStore/getCustomerById",
  async ({ customerId }, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.getCustomerById(customerId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createCustomer = createAsyncThunk(
  "customerStore/createCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CustomerStoreService.createCustomer(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateCustomer = createAsyncThunk(
  "customerStore/updateCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CustomerStoreService.updateCustomer(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const changePhoneCustomer = createAsyncThunk(
  "customerStore/changePhoneCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CustomerStoreService.changePhoneCustomer(data);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        "Đã đổi số điện thoại khách hàng",
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteCustomer = createAsyncThunk(
  "customerStore/deleteCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const { customerId, storeId, onSuccess } = data;

      const response = await CustomerStoreService.deleteCustomer({
        id: customerId,
        storeId: storeId || null,
      });

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportExcelCustomer = createAsyncThunk(
  "customerStore/exportExcelCustomer",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await CustomerStoreService.exportExcelCustomer(params);
      const url = window.URL.createObjectURL(blob);
      const filename = `Danh sách khách hàng_${moment().format("YYYYMMDD")}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const importGoogleSheetsCustomer = createAsyncThunk(
  "customerStore/importGoogleSheetsCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response =
        await CustomerStoreService.importGoogleSheetsCustomer(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const settingCustomerRewardV2 = createAsyncThunk(
  "customerStore/settingCustomerReward",
  async (data, { rejectWithValue }) => {
    try {
      const { payload, onSuccess } = data;
      const response =
        await CustomerStoreService.settingCustomerReward(payload);
      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getHistoryOrdersCustomer = createAsyncThunk(
  "customerStore/getHistoryOrdersCustomer",
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await CustomerStoreService.getHistoryOrdersCustomer(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loadingList: false,
  loadingDetail: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingImport: false,
  loadingExport: false,
  loadingHistoryOrder: false,
  loadingSetting: false,
  loadingChangePhone: false,

  customerStoreList: [],
  historyOrderList: [],
  customerStoreDetail: {},

  customerStoreListV2: [],
  historyOrderListV2: [],
  customerStoreDetailV2: {},
};

export const customerSlice = createSlice({
  name: "customerStore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET LIST
      .addCase(getAllCustomerStore.pending, (state) => {
        state.loadingList = true;
      })
      .addCase(getAllCustomerStore.fulfilled, (state, action) => {
        state.loadingList = false;
        state.customerStoreList = action.payload;
      })
      .addCase(getAllCustomerStore.rejected, (state) => {
        state.loadingList = false;
      })

      // GET History Order
      .addCase(getHistoryOrders.pending, (state) => {
        state.loadingHistoryOrder = true;
      })
      .addCase(getHistoryOrders.fulfilled, (state, action) => {
        state.loadingHistoryOrder = false;
        state.historyOrderList = action.payload;
      })
      .addCase(getHistoryOrders.rejected, (state) => {
        state.loadingHistoryOrder = false;
      })

      // GET DETAIL
      .addCase(getCustomerStoreById.pending, (state) => {
        state.loadingDetail = true;
      })
      .addCase(getCustomerStoreById.fulfilled, (state, action) => {
        state.loadingDetail = false;
        state.customerStoreDetail = action.payload;
      })
      .addCase(getCustomerStoreById.rejected, (state) => {
        state.loadingDetail = false;
      })

      // CREATE
      .addCase(createCustomerStore.pending, (state) => {
        state.loadingCreate = true;
      })
      .addCase(createCustomerStore.fulfilled, (state) => {
        state.loadingCreate = false;
      })
      .addCase(createCustomerStore.rejected, (state) => {
        state.loadingCreate = false;
      })

      // UPDATE
      .addCase(updateCustomerStore.pending, (state) => {
        state.loadingUpdate = true;
      })
      .addCase(updateCustomerStore.fulfilled, (state) => {
        state.loadingUpdate = false;
      })
      .addCase(updateCustomerStore.rejected, (state) => {
        state.loadingUpdate = false;
      })

      // DELETE
      .addCase(deleteCustomerStore.pending, (state) => {
        state.loadingDelete = true;
      })
      .addCase(deleteCustomerStore.fulfilled, (state) => {
        state.loadingDelete = false;
      })
      .addCase(deleteCustomerStore.rejected, (state) => {
        state.loadingDelete = false;
      })

      // IMPORT
      .addCase(importCustomerGoogleSheets.pending, (state) => {
        state.loadingImport = true;
      })
      .addCase(importCustomerGoogleSheets.fulfilled, (state) => {
        state.loadingImport = false;
      })
      .addCase(importCustomerGoogleSheets.rejected, (state) => {
        state.loadingImport = false;
      })

      // EXPORT
      .addCase(exportCustomerStoreExcel.pending, (state) => {
        state.loadingExport = true;
      })
      .addCase(exportCustomerStoreExcel.fulfilled, (state) => {
        state.loadingExport = false;
      })
      .addCase(exportCustomerStoreExcel.rejected, (state) => {
        state.loadingExport = false;
      })

      // CUSTOMER V2
      // GET LIST
      .addCase(getAllCustomer.pending, (state) => {
        state.loadingList = true;
      })
      .addCase(getAllCustomer.fulfilled, (state, action) => {
        state.loadingList = false;
        state.customerStoreListV2 = action.payload;
      })
      .addCase(getAllCustomer.rejected, (state) => {
        state.loadingList = false;
      })

      // GET DETAIL
      .addCase(getCustomerById.pending, (state) => {
        state.loadingDetail = true;
      })
      .addCase(getCustomerById.fulfilled, (state, action) => {
        state.loadingDetail = false;
        state.customerStoreDetailV2 = action.payload;
      })
      .addCase(getCustomerById.rejected, (state) => {
        state.loadingDetail = false;
      })

      // CREATE
      .addCase(createCustomer.pending, (state) => {
        state.loadingCreate = true;
      })
      .addCase(createCustomer.fulfilled, (state) => {
        state.loadingCreate = false;
      })
      .addCase(createCustomer.rejected, (state) => {
        state.loadingCreate = false;
      })

      // UPDATE
      .addCase(updateCustomer.pending, (state) => {
        state.loadingUpdate = true;
      })
      .addCase(updateCustomer.fulfilled, (state) => {
        state.loadingUpdate = false;
      })
      .addCase(updateCustomer.rejected, (state) => {
        state.loadingUpdate = false;
      })

      // CHANGE PHONE
      .addCase(changePhoneCustomer.pending, (state) => {
        state.loadingChangePhone = true;
      })
      .addCase(changePhoneCustomer.fulfilled, (state) => {
        state.loadingChangePhone = false;
      })
      .addCase(changePhoneCustomer.rejected, (state) => {
        state.loadingChangePhone = false;
      })

      // DELETE
      .addCase(deleteCustomer.pending, (state) => {
        state.loadingDelete = true;
      })
      .addCase(deleteCustomer.fulfilled, (state) => {
        state.loadingDelete = false;
      })
      .addCase(deleteCustomer.rejected, (state) => {
        state.loadingDelete = false;
      })

      // EXPORT
      .addCase(exportExcelCustomer.pending, (state) => {
        state.loadingExport = true;
      })
      .addCase(exportExcelCustomer.fulfilled, (state) => {
        state.loadingExport = false;
      })
      .addCase(exportExcelCustomer.rejected, (state) => {
        state.loadingExport = false;
      })

      // IMPORT
      .addCase(importGoogleSheetsCustomer.pending, (state) => {
        state.loadingImport = true;
      })
      .addCase(importGoogleSheetsCustomer.fulfilled, (state) => {
        state.loadingImport = false;
      })
      .addCase(importGoogleSheetsCustomer.rejected, (state) => {
        state.loadingImport = false;
      })

      // GET History Order
      .addCase(getHistoryOrdersCustomer.pending, (state) => {
        state.loadingHistoryOrder = true;
      })
      .addCase(getHistoryOrdersCustomer.fulfilled, (state, action) => {
        state.loadingHistoryOrder = false;
        state.historyOrderListV2 = action.payload;
      })
      .addCase(getHistoryOrdersCustomer.rejected, (state) => {
        state.loadingHistoryOrder = false;
      })

      // SETTING REWARD
      .addCase(settingCustomerRewardV2.pending, (state) => {
        state.loadingSetting = true;
      })
      .addCase(settingCustomerRewardV2.fulfilled, (state) => {
        state.loadingSetting = false;
      })
      .addCase(settingCustomerRewardV2.rejected, (state) => {
        state.loadingSetting = false;
      });
  },
});

export default customerSlice.reducer;